import React from 'react'
import PropTypes from 'prop-types'
import * as styles from './_FieldGroup.scss'
import { Form
  , InputGroup } from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css';
import classNames from 'classnames'

const inputGroupAddonStyles = styles['ag-input-group-addon']
const prefixStyles = inputGroupAddonStyles + ' ' + styles['prefix']

const FieldGroup = ({
  id
  , children
  , label
  , message
  , isInvalid
  , handleChange
  , required
  , value
  , prefix
  , type
  , handleKeyPress
  , fieldGroupClass
  , suffix
  , onFocus
  , onBlur
  , ...remainingProps
}) => {
  let inputSpan = null

  return (
    <Form.Group className={classNames(styles['field-group-spacing'], fieldGroupClass)} controlId={id} >
      {label && label.length > 0 ? <Form.Label className={classNames(required ? styles['required'] : null, styles['form-label'])}>{label}</Form.Label> : ''}
      <InputGroup style={{maxWidth: type === 'number' ? '400px' : 'initial', width: '100%'}} >
        <span ref={(span) => { inputSpan = span }} className={styles['ag-input-group']}>
          {prefix && <InputGroup.Text className={classNames(prefixStyles, styles['input-group-text'])}>{prefix}</InputGroup.Text>}
          <Form.Control
            type={type}
            className={styles['ag-input-box']}
            value={value}
            isInvalid={isInvalid}
            onChange={(event) => {
              handleChange(event.target.value, event.target)
            }}
            onFocus={(e) => {
              inputSpan.className += (' ' + styles['input-focussed'])
              if (onFocus) {
                onFocus(e)
              }
            }}
            onBlur={(e) => {
              inputSpan.className = inputSpan.className.replace(styles['input-focussed'], '')
              if (onBlur) {
                onBlur(e)
              }
            }}
            onKeyPress={handleKeyPress}
            {...remainingProps} />
        </span>
        {suffix && <InputGroup.Text className={inputGroupAddonStyles}>{suffix}</InputGroup.Text>}
        { children }
      </InputGroup>
      {message && <Form.Text className={styles['help-block-font-size']}>{message}</Form.Text>}
    </Form.Group>)
}

FieldGroup.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
  label: PropTypes.string,
  message: PropTypes.string,
  isInvalid: PropTypes.bool,
  handleChange: PropTypes.func,
  handleKeyPress: PropTypes.func,
  required: PropTypes.bool,
  fieldGroupClass: PropTypes.string,
  suffix: PropTypes.node,
  prefix: PropTypes.string,
  type: PropTypes.string,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired
}

export default (FieldGroup)
